import { Injectable } from '@angular/core';
import { Resource, Service } from 'ngx-jsonapi';
@Injectable({
    providedIn: 'root'
})
export class GroupHistoricalRateService extends Service<GroupHistoricalRate> {
    public resource: typeof GroupHistoricalRate = GroupHistoricalRate;
    public type: string = 'group_historical_rates';
    public constructor() {
        super();
        this.register();
    }
}
export class GroupHistoricalRate extends Resource {
    public type: string = 'group_historical_rates';
    public attributes: {
        id: string;
        date: string;
        pair: string;
        ask_price: number;
        bid_price: number;
    } = {
        id: '',
        date: '',
        pair: '',
        ask_price: 0,
        bid_price: 0
    };
}
